import { DEFAULT_CURRENCY_SELECTOR_MODAL_CURRENCIES } from "./constants";
import { convertCurrencyAction } from "@/app/actions/currency";

type CurrencyCode =
  (typeof DEFAULT_CURRENCY_SELECTOR_MODAL_CURRENCIES)[number]["code"];

/**
 * Client-side currency conversion using FX Quote API via Server Action.
 *
 * When a locked rate is provided (from the FX quote session cookie),
 * it is used directly for instant, consistent conversion without a server round-trip.
 * Falls back to the indicative rate server action when no locked rate is available.
 *
 * @param usdPrice - The price in USD to convert
 * @param targetCurrency - Target currency code
 * @param lockedRate - Optional locked rate from session; skips server call when present
 * @returns The converted amount or null if conversion fails
 */
export async function convertCurrencyFXQuoteClient(
  usdPrice: number,
  targetCurrency: CurrencyCode,
  lockedRate?: number | null,
): Promise<number | null> {
  if (targetCurrency === "USD") {
    return usdPrice;
  }

  if (lockedRate != null && lockedRate > 0) {
    return usdPrice * lockedRate;
  }

  try {
    return await convertCurrencyAction(usdPrice, "USD", targetCurrency);
  } catch {
    return null;
  }
}
